import { PAGE_SIZE_OPTIONS } from '@/types/pagination';

export function normalisePageSize(size: number, fallback: number): number {
  return (PAGE_SIZE_OPTIONS as readonly number[]).includes(size) ? size : fallback;
}
